import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Modal, Popup } from 'semantic-ui-react';
import _ from 'lodash';
import { compose } from 'recompose';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';

const iconStyle = {
  cursor: 'pointer',
};

const divStyle = {
  padding: '5px 30px',
};

class TokenStatusModal extends Component {
  //
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isError: false,
      tokenState: null,
    };
  }

  async componentDidMount() {
    const { buildRESTClient, channel, influencer } = this.props;
    const apiClient = buildRESTClient({
      baseURL: process.env.REACT_APP_STORY_SERVICE_API,
    });
    const response = await apiClient(`influencer/${influencer.id}/tokens/${channel}/info`).catch(() => {
      this.setState({
        isLoading: false,
        isError: false,
      });
    });
    if (response) {
      this.setState({
        isLoading: false,
        isError: false,
        tokenState: _.get(response, 'data.data'),
      });
    }
  }

  render() {
    const { userInfo, channel, handle } = this.props;
    const { tokenState } = this.state;
    if (userInfo.isDyzioUser) {
      return (
        <Modal
          trigger={
            <Icon
              style={iconStyle}
              name="warning circle"
              color="orange"
              size="large"
            />
          }
          content={
            <div style={divStyle}>
              <pre>
                {JSON.stringify(tokenState, null, 2) }
              </pre>
            </div>
          }
        />

      );
    }
    return (
      <Popup
        trigger={<Icon name="warning circle" color="orange" size="large" />}
        content={`Something went wrong accessing data from ${_.upperFirst(channel)} channel ${handle}`}
      />
    );
  }
}

TokenStatusModal.propTypes = {
  channel: PropTypes.string.isRequired,
  influencer: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(TokenStatusModal);



/** WEBPACK FOOTER **
 ** ./src/containers/token-status-modal/index.js
 **/